import React from 'react';
import { Field } from 'redux-form';
import cx from 'classnames';
import range from 'lodash.range';
import Input from '../Forms/Input';
import SelectField from '../Forms/SelectField';
import styles from './AdditionalInformationFields.css';
import required from '../../utils/fieldRequired';
import trimWhiteSpace from '../../utils/trimWhiteSpace';
import states from '../../../constants/states';

const emptyOption = {
    value: '',
    text: '',
    key: -1,
};

const graduationYearOptions = [emptyOption, {
    value: 2014,
    text: '2014 or before',
    key: 1,
}, ...range(2015, 2023).map(value => ({
    value,
    text: value,
    key: value,
})), {
    value: '2023 or later',
    text: '2023 or later',
    key: 3,
}];

const optionsForStates = Object.keys(states).map(value => ({
    value,
    text: value,
    key: value,
}));

optionsForStates.unshift(emptyOption);


const validateMobile = (value) => {
    if (value == null || trimWhiteSpace(value) === '') {
        return undefined;
    }

    if (!/^\d{10}$/.test(value)) {
        return 'Please enter valid phone number';
    }
    return undefined;
};

const UbeuAdditionalInformationFields = () => (<div>
    <div className={styles.row}>
        <Field
            name="mobilePhone"
            label="Mobile Phone"
            component={Input}
            className={styles.input}
            validate={validateMobile}
        />
        <Field
            name="graduationYear"
            label="HS Graduation Year"
            component={SelectField}
            className={styles.input}
            validate={required}
            options={graduationYearOptions}
        />
    </div>
    <div className={styles.row}>
        <Field
            name="streetAddress"
            label="Street Address"
            component={Input}
            className={cx(styles.input, styles.size7)}
            validate={required}
        />
        <Field
            name="unit"
            label={<span>
                Unit <span className={styles.optional}>(OPTIONAL)</span>
            </span>}
            component={Input}
            className={cx(styles.input, styles.size3)}
        />
    </div>
    <div className={styles.row}>
        <Field
            name="city"
            label="City"
            component={Input}
            className={cx(styles.input, styles.size6)}
            validate={required}
        />
        <Field
            name="state"
            label="State"
            component={SelectField}
            className={cx(styles.input, styles.size2)}
            options={optionsForStates}
            validate={required}
        />
        <Field
            name="zip"
            label="Zip Code"
            autoComplete="off"
            component={Input}
            className={cx(styles.input, styles.size2)}
            validate={required}
        />
    </div>
</div>);

UbeuAdditionalInformationFields.propTypes = {};

export default UbeuAdditionalInformationFields;



// WEBPACK FOOTER //
// ./src/client/Components/ExtraUserInformation/UbeuAdditionalInformationFields.js